import {
  boolean as sanitizeBoolean,
  string as sanitizeString,
} from 'olapic-js-utils/browser/sanitize';

const routeProviderConfig = ($routeProvider) => {
  'ngInject';

  $routeProvider
  .when('/login', {
    template: ({ expired }) => `
      <login-container session-expired="${sanitizeBoolean(expired)}"></login-container>
    `,
    requiresAnonymous: true,
  })
  .when('/logout', {
    template: '<logout-container></logout-container>',
  })
  .when('/remember-password', {
    template: '<remember-container></remember-container>',
    requiresAnonymous: true,
  })
  .when('/reset-password/:code/:ref?', {
    template: ({ code, ref }) => `
      <reset-password-container
        create="false"
        code="${sanitizeString(code)}"
        ref-code="${sanitizeString(ref)}"
      ></reset-password-container>
    `,
    requiresAnonymous: true,
  })
  .when('/create-password/:code', {
    template: ({ code }) => `
      <reset-password-container
        create="true"
        code="${sanitizeString(code)}"
      ></reset-password-container>
    `,
    requiresAnonymous: true,
  });
};

export default routeProviderConfig;
